import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: false, name: 'capitalize'})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, args: any[] = null): string {
    if (value === null) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
